import React from "react";
import ReactDOM from "react-dom";
import ProductDetails from "../../components/modules/products/ProductDetails.jsx";

const element = document.getElementById("product-new");
if (element !== null) {
    ReactDOM.render(
        <ProductDetails
            slug={element.dataset.slug}
            enablenews={element.dataset.enablenews}
            details={JSON.parse(element.dataset.json)}
        />,
        element
    );
}
